import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class TabIndexService {
  selectedInput: BehaviorSubject<number> = new BehaviorSubject<number>(1);
}
